import { render, staticRenderFns } from "./TableChartThree.vue?vue&type=template&id=cba40e72&"
import script from "./TableChartThree.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TableChartThree.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports